export default __webpack_public_path__ + "static/media/support-email.d8c2a379.svg";